<template>
  <div
    class="offer-timer"
    :style="{
      background: colors[color].mainBgColor,
      'justify-content': justify,
      'border-radius': isRounded ? '0.35rem' : '',
    }"
  >
    <span class="offer-timer_span" :style="{ color: colors[color].mainTextColor }">Esta oferta se encerrará em:</span>
    <div class="offer-timer-counter">
      <div class="offer-timer-counter-div" v-for="(time, index) in type" :key="time">
        <div class="offer-timer-counter-div_content" :style="{ 'background-color': colors[color].counterBgColor }">
          <span class="offer-timer-counter-div_content-time" :style="{ color: colors[color].counterTimerColor }">{{
            time.value
          }}</span>
          <span class="offer-timer-counter-div_content-info" :style="{ color: colors[color].counterTimerColor }">{{
            time.label
          }}</span>
        </div>
        <span
          class="offer-timer-counter-div_separator"
          :style="{ color: colors[color].mainTextColor, display: type.length === index + 1 ? 'none' : 'block' }"
        >
          :
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import useOfferCountDown from '@/composables/useOfferCountDown.js';
import { colors } from './colors';
import { useStore } from 'vuex';

const store = useStore();

const emit = defineEmits(['finishOffer']);
const props = defineProps({
  color: {
    type: String,
    default: 'primary',
  },
  isRounded: {
    type: Boolean,
    default: false,
  },
  justify: {
    type: String,
    default: 'center',
  },
  type: {
    type: String,
    default: 'days',
  },
  expireAt: {
    type: String,
  },
});

const { seconds, minutes, hours, days, getDifference, start } = useOfferCountDown();

const type = computed(() => {
  let slicedValues = [
    {
      value: days,
      label: 'Dias',
    },
    {
      value: hours,
      label: 'Horas',
    },
    {
      value: minutes,
      label: 'Minutos',
    },
    {
      value: seconds,
      label: 'Segundos',
    },
  ];

  switch (props.type) {
    case 'days':
      slicedValues = slicedValues.slice(0);
      break;
    case 'hours':
      slicedValues = slicedValues.slice(1, 4);
      break;
    case 'minutes':
      slicedValues = slicedValues.slice(2, 4);
      break;
    case 'seconds':
      slicedValues = slicedValues.slice(3, 4);
      break;
  }

  return slicedValues;
});

watch(getDifference, () => {
  if (getDifference.value <= 0) {
    emit('finishOffer');
  }
});

onMounted(async () => {
  const dateNow = await store.dispatch('time/getDateNow');
  const currentDate = new Date(dateNow).getTime();
  const offerExpire = new Date(props.expireAt).getTime();
  if (currentDate > offerExpire) {
    emit('finishOffer');
    return;
  }
  start(offerExpire, currentDate);
});
</script>

<style scoped lang="scss">
.offer-timer {
  width: 100%;
  display: flex;
  padding: 0.5rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    padding: 0.8rem;
    flex-direction: column;
    gap: 0.5rem;
  }
  &_span {
    margin-right: 1rem;
    font-weight: bold;
    margin-left: 1.5rem;
  }
  &-counter {
    display: flex;
    align-items: center;
    margin-right: 1.5rem;
    @media (max-width: 700px) {
      margin-right: 0rem;
    }
    &-div {
      display: flex;
      align-items: center;
      &_separator {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        font-weight: bold;
        font-size: 1.5rem;
      }
      &_content {
        width: 4.75rem;
        @media (max-width: 400px) {
          width: 4rem;
        }
        height: 3.5rem;
        padding: 0.5rem;
        border-radius: 0.37rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &-time {
          font-weight: 700;
          font-size: 1.5rem;
        }
        &-info {
          font-weight: 600;
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
